import { fetchUserAnalyticsKpis } from "./fetchUserAnalyticsKpis";
import { useUserAnalyticsDateRangeQuery } from "./useUserAnalyticsDateRangeQuery";
import type {
  UserAnalyticsKpisQueryParams,
  UserAnalyticsKpisResult,
} from "./userAnalyticsKpisTypes";

export const USER_ANALYTICS_KPIS_QUERY_KEY = "USER_ANALYTICS_KPIS" as const;

/**
 * Loads the aggregate KPIs for the Acquisition tab. The query key incorporates
 * the date range so the cache invalidates whenever the user picks a new window.
 * Mirrors the staleness / focus behaviour of `useSportsbookAnalyticsKpis`.
 */
export function useUserAnalyticsKpis(params: UserAnalyticsKpisQueryParams) {
  return useUserAnalyticsDateRangeQuery<UserAnalyticsKpisResult>(
    USER_ANALYTICS_KPIS_QUERY_KEY,
    params,
    () => fetchUserAnalyticsKpis(params),
  );
}
